import React, { useEffect, useState, useRef } from "react";
import { Formio } from "@formio/react";
import { useNavigate, useParams } from "react-router-dom";
import EntityConstants from "../../configs/EntityConstants";
import Toast from "../Toast/Toast";
import { POST, GET } from "../../service/CRUDService";
import FullScreenLoader from "../FullScreenLoader/FullScreenLoader";
import CfLoader from "../CfLoader/CfLoader";

const FormioSingleUpload = ({
  URL,
  formFieldsChanged,
  transaction_name,
  isToggleOn,
  creditCount,
  isPostPaid,
}) => {
  const { issuer_credential_template_id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const hasSufficientCredits = isPostPaid || creditCount > 0;
  const navigate = useNavigate();
  const [notificationMode, setNotificationMode] = useState(
    "without_notification"
  );
  const notificationModeRef = useRef(notificationMode);

  useEffect(() => {
    notificationModeRef.current = notificationMode;
  }, [notificationMode]);

  useEffect(() => {
    GET(EntityConstants.GET_ORG_DETAILS)
      .then((response) => response.json())
      .then((data) => {
        const isEnabled = data.enable_email_notification === true;

        if (isEnabled) {
          setNotificationMode("with_notification");
        } else {
          setNotificationMode("without_notification");
        }
      })
      .catch((error) => {
        console.error("Error fetching organization details:", error);
        setNotificationMode("without_notification");
      });
  }, []);

  const handleNotificationChange = (e) => {
    const mode = e.target.value;
    setNotificationMode(mode);
  };

  const onSubmitHandle = async (
    transaction_name,
    sub,
    currentNotificationMode
  ) => {
    const payload = sub;
    try {
      setIsSubmitting(true);

      // USE STATE VALUE INSTEAD OF LOCALSTORAGE
      let apiUrl = `${EntityConstants.POST_CREDENTIALS_SINGLE_ISSUANCE}${issuer_credential_template_id}`;
      apiUrl +=
        currentNotificationMode === "with_notification"
          ? "&mode_of_issuance=issue_and_notify"
          : "&mode_of_issuance=issue";

      const response = await POST(apiUrl, payload);
      const data = await response.json();

      if (response.ok) {
        setIsSubmitting(false);
        Toast({
          type: "success",
          title: "Success",
          message: data.message,
        });
        navigate(
          `/issuer/workspace/batches/summary/${data.credential_template_id}/${data.issuer_credential_template_id}?templateType=${data.template_type}`,
          {
            state: {
              transaction_id: data.transaction_id,
              programme: data.programme_name,
              batch: data.batch_name,
            },
          }
        );
      } else {
        Toast({
          type: "error",
          title: "Error",
          message: data.message,
        });
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      setIsSubmitting(false);
    }
  };

  const disableSubmitButton = (form) => {
    const submitButton = form.element.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = !hasSufficientCredits;
    }
  };

  useEffect(() => {
    URL &&
      fetch(URL)
        .then((resp) => resp.json())
        .then((data) => {
          if (!transaction_name) return;

          Formio.createForm(document.getElementById("formio"), data).then(
            (form) => {
              form.submission = {
                data: isToggleOn ? { ...URL.data } : {},
              };
              form.on("change", formFieldsChanged);
              form.on("submit", (sub) => {
                if (hasSufficientCredits) {
                  onSubmitHandle(
                    transaction_name,
                    sub,
                    notificationModeRef.current
                  );
                } else {
                  Toast({
                    type: "warning",
                    title: "Insufficient Credits",
                    message:
                      "You do not have enough credits to issue credentials",
                  });
                  disableSubmitButton(form);
                }
              });
              disableSubmitButton(form);
            }
          );
        });
  }, [URL, transaction_name, isToggleOn, hasSufficientCredits]);

  return (
    <div className="w-full pb-2">
      <div id="formio" className="flex flex-col w-full ">
        <div className="flex justify-center items-center ">
          <CfLoader />
        </div>
      </div>

      {/* Notification Mode Dropdown */}
      <div className="my-4">
        <label
          htmlFor="notification-mode"
          className="block text-[16px] font-medium text-cfGlobalText mb-1"
        >
          Send Notification
        </label>
        <select
          id="notification-mode"
          value={notificationMode}
          onChange={handleNotificationChange}
          className="block w-full px-3 py-2 border border-cfIssuedScreenSearchBorder rounded-md shadow-sm focus:outline-none focus:ring-cfPrimary focus:border-cfPrimary sm:text-sm"
        >
          <option value="with_notification">Yes</option>
          <option value="without_notification">No</option>
        </select>
      </div>

      {isSubmitting && <FullScreenLoader />}
    </div>
  );
};

export default FormioSingleUpload;
